import { render, staticRenderFns } from "./WelcomePopupV3.vue?vue&type=template&id=f1a49eba&scoped=true&"
import script from "./WelcomePopupV3.vue?vue&type=script&lang=js&"
export * from "./WelcomePopupV3.vue?vue&type=script&lang=js&"
import style0 from "./WelcomePopupV3.vue?vue&type=style&index=0&id=f1a49eba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1a49eba",
  null
  
)

export default component.exports